document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-locale-select]').forEach(btn=>btn.addEventListener('click',()=>{
    const form=btn.closest('form'); if(!form) return;
    const input=form.querySelector('input[name="locale_code"]');
    if(!input) return;
    input.value=btn.dataset.localeSelect; form.submit();
  }));

  document.querySelectorAll('[data-quantity-stepper]').forEach(stepper=>{
    const input=stepper.querySelector('.qty-input');
    const minus=stepper.querySelector('[data-qty-minus]');
    const plus=stepper.querySelector('[data-qty-plus]');
    if(!input) return;
    const min=()=>Number(input.getAttribute('min') || 1);
    const normalize=()=>{ let value=parseInt(input.value,10); if(Number.isNaN(value)) value=min(); input.value=Math.max(min(),value); };
    if(minus) minus.addEventListener('click',()=>{ normalize(); input.value=Math.max(min(),parseInt(input.value,10)-1); input.dispatchEvent(new Event('change',{bubbles:true})); });
    if(plus) plus.addEventListener('click',()=>{ normalize(); input.value=parseInt(input.value,10)+1; input.dispatchEvent(new Event('change',{bubbles:true})); });
    input.addEventListener('blur',normalize);
  });

  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    const form=select.closest('[data-product-form]');
    if(!form) return;
    const refresh=()=>{
      const option=select.options[select.selectedIndex];
      const available=option && option.dataset.available !== 'false' && !option.disabled;
      form.querySelectorAll('.cod-checkout-btn,.add-cart-btn').forEach(btn=>{ btn.disabled=!available; });
    };
    select.addEventListener('change',refresh); refresh();
  });
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-direct-checkout]');
  if (!button) return;
  const form = button.closest('form');
  if (!form || button.disabled) return;
  event.preventDefault();
  const original = button.innerHTML;
  button.disabled = true;
  button.setAttribute('aria-busy','true');
  try {
    const data = new FormData(form);
    const response = await fetch('/cart/add.js', { method:'POST', body:data, headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'} });
    if (!response.ok) {
      let message='Unable to add product';
      try { const err=await response.json(); message=err.description || err.message || message; } catch(e) {}
      throw new Error(message);
    }
    window.location.assign('/checkout');
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = original;
    const notice=document.createElement('div');
    notice.className='cart-error';
    notice.textContent=error.message || 'This item is currently unavailable. Please check product inventory in Shopify.';
    form.appendChild(notice);
    setTimeout(()=>notice.remove(),6000);
  }
});
